
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tc",
      function () {
        return require("private-next-pages/tc.js");
      }
    ]);
  